"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const alert_1 = require("components/cosmos/alert");
const button_1 = __importDefault(require("components/cosmos/button/button"));
const Html_1 = __importDefault(require("components/Html"));
const translate_1 = require("components/translate");
const withFeatureToggle_1 = require("hoc/withFeatureToggle");
const useModal_1 = require("hooks/useModal");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const legacyRedirect_1 = require("modules/app/services/datahub/legacyRedirect");
const FeatureToggleConstants_1 = require("modules/featureToggle/FeatureToggleConstants");
const modalMoreInfo_1 = require("./modalMoreInfo");
const useLegacyClubRedirect_1 = __importDefault(require("./useLegacyClubRedirect"));
const LegacyClubRedirectAlert = ({ productId, t }) => {
    const { handleOpen, handleClose, isModalOpen } = (0, useModal_1.useModal)();
    const { shouldRenderAlert, hasNewClub, handleCloseAlert } = (0, useLegacyClubRedirect_1.default)(productId);
    if (!shouldRenderAlert || !hasNewClub) {
        return null;
    }
    const handleKnowMoreClick = () => {
        legacyRedirect_1.DatahubLegacyRedirectService.showMoreInfoEvent();
        handleOpen();
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(alert_1.Alert, { type: "warning", onDismiss: () => handleCloseAlert(false), dismissible: true, className: "_mb-6 _d-flex _align-content-start", children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'exclamation-triangle'], className: "_mr-3 _w-5 _h-5 _text-gray-900" }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Html_1.default, { tag: "p", className: "_my-0 _text-gray-500", children: t('legacy_club_redirect.alert.description') }), (0, jsx_runtime_1.jsx)(button_1.default, { className: "_mt-4", onClick: handleKnowMoreClick, variation: "info", children: t('general.know_more') })] })] }), isModalOpen && (0, jsx_runtime_1.jsx)(modalMoreInfo_1.ModalMoreInfo, { onClose: handleClose })] }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)(({ MembershipStore }) => ({
    productId: MembershipStore.productId
})))((0, withFeatureToggle_1.withFeatureToggle)(LegacyClubRedirectAlert, FeatureToggleConstants_1.FeatureToggles.LegacyRedirectAlert));
